import { MultiStrategyScreenTable } from "@/domains/trade-ideas/components/MultiStrategyScreenTable";
import type { ApiFn } from "@/shared/lib/types";
import { Link } from "react-router-dom";

// JS-1098: the pre-desk-era "Setups worth your attention" hero, the
// setup-first decision queue, its scan-coverage/universe-funnel/legacy
// compatibility rendering, and their detail dialogs were removed from this
// page -- the owner ruled the LEGACY setups-list surface must go now that
// the desk surface below (MultiStrategyScreenTable, "Best Trade Ideas") is
// the page's single source of trade ideas. The setups DATA/API/pipeline are
// untouched; only this page's rendering of them was deleted. See
// SetupDetailDialog.tsx et al.'s removal in this same change for the full
// list of now-dead components.
export default function TradeIdeasPage({ api }: { api: ApiFn }) {
  return (
    <div className="min-w-0 space-y-6">
      {/* JS-1098 (Codex round, MEDIUM): a real document-structure h1 -- the
          page previously had none once the LEGACY "Setups worth your
          attention" hero (its own h1) was removed, and
          MultiStrategyScreenTable's internal "Best Trade Ideas" heading is
          an h2, not a page title. Visually hidden to keep the desk
          surface's chrome-free look (MultiStrategyScreenTable's own heading
          already reads as the visible page title); the accessibility tree
          still gets exactly one h1. */}
      <h1 className="sr-only">Trade ideas</h1>
      <MultiStrategyScreenTable api={api} />

      {/* JS-1094 (demo blocker FIX 1): a permanent "Ledger" link, alongside
          the existing Edition link -- the ledger was previously only
          reachable from the edition's Scoreboard strip, and ONLY once
          `running_record_total` was nonzero (see EditionPage.tsx's
          ScoreboardStrip, which shows no link at all on an honestly-empty
          record). That made the audit-grade ledger unreachable on a fresh
          demo/desk with no resolved ideas yet -- this link is unconditional,
          reachable regardless of the record's current state. */}
      <p className="flex flex-wrap gap-x-3 text-[11px] text-muted-foreground">
        <Link to="/portal/trade-ideas/edition" className="underline decoration-dotted underline-offset-2 hover:text-foreground">
          Internal · Today's edition
        </Link>
        <Link to="/portal/trade-ideas/ledger" className="underline decoration-dotted underline-offset-2 hover:text-foreground">
          Internal · Outcome ledger
        </Link>
      </p>

      <footer className="text-xs leading-relaxed text-muted-foreground">Prices are quoted markets, not guaranteed fills. Payoff figures are at expiration, exclude fees, and can change with entry price. Confirm live conditions before trading.</footer>
    </div>
  );
}
